import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { organizationEntityToModel } from 'shared/domain/organization/mapping/toModel';
import { OrganizationModel } from 'shared/domain/organization/types/model';
import * as dbOrganizations from '../../db/organizations/organizations';
import * as dbOrganizationsService from '../../db/organizations/organizationsService';
import { organizationContract } from 'shared/domain/organization/organizationContract';
import { makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

/** Every organization of IndexedDB as a model. */
export async function readOrganizationModels(): Promise<OrganizationModel[]> {
  const organizations = await dbOrganizations.get();
  return organizations.map(organizationEntityToModel);
}

export const broadcastAllOrganizations = makeLoadedEventPublisher(
  organizationContract,
  DomainMessagesTypes.allOrganizations,
  () => readCollectionPayload(dbOrganizationsService, readOrganizationModels)
);
